import { Component, OnInit, Input, Optional, Self, ViewChild } from '@angular/core';
import { LookupService, LookupItem, ValidationMessageService } from 'src/app/stp/stp-app/forms';
import { NgControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { SelectComponent } from '../../select/select/select.component';

@Component({
  selector: 'stp-lookup',
  templateUrl: './lookup.component.html',
  styleUrls: ['./lookup.component.scss']
})
export class LookupComponent implements OnInit {

  @Input() label: string;
  @Input() required: boolean;
  @Input() hint?: string;
  @Input() errorMessage?: string;
  @Input() lookupName: string;
  @Input() multiple = false;
  @Input() isGrouped = false;

  @ViewChild(SelectComponent) private stpSelect: SelectComponent;

  lookupItems: Observable<LookupItem[]>;
  groupNames: Observable<string[] | any>;
  isErrorState = false;
  loading = false;

  constructor(
    @Optional() @Self() private ngControl: NgControl,
    private lookupService: LookupService,
    public validationMessageService: ValidationMessageService) {
     if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (this.ngControl) {
      this.stpSelect.ngControl = this.ngControl;
    }

    if (!this.lookupName) {
      this.lookupName = this.lookupService.getDefaultLookupName(this.lookupName || this.ngControl.name);
    }

    this.lookupItems = this.loadLookups();
  }

  writeValue(obj: any): void {
    this.stpSelect.writeValue(obj);
  }

  registerOnChange(fn: any): void {
    this.stpSelect.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.stpSelect.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.stpSelect.setDisabledState(isDisabled);
  }

  filterOptions = (lookupItems: LookupItem[]) => {
    return lookupItems.filter(lookupItem => !lookupItem.archived || (this.ngControl.value === lookupItem.id));
  }

  private loadLookups() {
    return <Observable<LookupItem[]>> (this.lookupName ? this.lookupService.getLookups(this.lookupName) : of([]));
  }
}
